// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_layouts_admin-layout_admin-layout_module_ts":"0f1e6e03219720e559c2","src_app_layouts_auth-layout_auth-layout_module_ts":"fdf440d71eb1b9b04dec"}[chunkId] + ".js";
};